<template>
  <div id="cee-challenge">
    <!-- <topnav /> -->
    <div id="cee-img" class="background-img">
      <div class="overlay cee-img__overlay" />
      <div class="img-caption">
        <h1 class="text-center">
          CEE Startup Challenge
        </h1>
        <h3>
          Join The Biggest Online Startup Challenge in Central &amp; Eastern
          Europe!
        </h3>
        <p class="hidden text-center">
          Applications start on April 9!
        </p>
        <router-link
          class="cta btn btn-primary btn-lg"
          :to="{ name: 'organizationPage', params: { orgId: 'vestbee' } }"
        >
          Apply until May 21!
        </router-link>

        <div class="countdown">
          <span>Only</span>
          <Countdown end="May 21, 2018" />
          <span>left</span>
        </div>
      </div>
    </div>

    <div class="marketing-content">
      <div class="row">
        <div>
          <h2 class="text-center">
            We Take Pitching To The E-level
          </h2>
          <h3 class="text-center">
            Tired of catching up with all startup competitions and events? Save
            time and find the best match without leaving your office!
          </h3>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div class="row startup-investor">
        <div class="column home-column">
          <div class="column-content">
            <div class="column-content__heading">
              <i class="ion ion-icon ion-paper-airplane" />
              <h3>Startups &amp; Scaleups</h3>
            </div>
            <ul>
              <li>
                Get wide exposure to leading global investors, corporates and
                media
              </li>
              <li>
                Gain priority access to the biggest matching platform in CEE and
                tools to automate and manage fundraising
              </li>
              <li>
                Apply for funding in one place and focus on growing your
                business
              </li>
            </ul>
            <router-link
              class="cta cta--secondary btn btn-primary btn-lg"
              :to="{ name: 'organizationPage', params: { orgId: 'vestbee' } }"
            >
              Apply
            </router-link>
          </div>
        </div>
        <!--End single item-->
        <div class="column home-column">
          <div class="column-content">
            <div class="column-content__heading">
              <i class="ion ion-icon ion-arrow-graph-up-right" />
              <h3>Investors &amp; Corporates</h3>
            </div>
            <ul>
              <li>
                Don’t miss the best startups and scaleups from Central &amp;
                Eastern Europe
              </li>
              <li>
                Get priority access to the biggest matching platform in CEE and
                arising investment opportunities
              </li>
              <li>
                Minimize workload with pre-screened deals aligned with your
                strategy
              </li>
            </ul>
            <a
              class="cta cta--secondary btn btn-primary btn-lg"
              a
              href="mailto: office@vestbee.com "
            >
              Get in Touch!
            </a>
          </div>
        </div>
        <!--End single item-->
      </div>
    </div>

    <div class="cee-sectors">
      <div class="cee-sectors__grid background-img">
        <div class="overlay cee-sectors__overlay" />
        <h2>Sectors</h2>
        <h3>
          We are looking for startups and scaleups with innovative solutions in
          sectors:
        </h3>
        <div class="cee-sectors__items">
          <div class="cee-sector__item">
            <i class="ion ion-ios-world-outline" />
            <p>Industry 4.0</p>
          </div>
          <div class="cee-sector__item">
            <i class="ion ion-ios-home-outline" />
            <p>Smart Cities &amp; Home</p>
          </div>
          <div class="cee-sector__item">
            <i class="ion ion-ios-lightbulb-outline" />
            <p>Energy &amp; Cleantech</p>
          </div>
          <div class="cee-sector__item">
            <i class="ion ion-ios-pulse" />
            <p>Life Science</p>
          </div>
          <div class="cee-sector__item">
            <i class="ion ion-ios-calculator-outline" />
            <p>Fintech</p>
          </div>
          <div class="cee-sector__item">
            <i class="ion ion-ios-pie-outline" />
            <p>Big Data &amp; Analytics</p>
          </div>
          <div class="cee-sector__item">
            <i class="ion ion-ios-briefcase-outline" />
            <p>Business &amp; ICT</p>
          </div>
          <div class="cee-sector__item">
            <i class="ion ion-ios-body-outline" />
            <p>Lifestyle</p>
          </div>
        </div>
      </div>
    </div>

    <div id="Steps" class="steps-section">
      <h2 class="steps-header">
        Timeline
      </h2>

      <div class="steps-timeline">
        <div class="steps-one">
          <p class="steps-date">
            21st May, 2018
          </p>
          <div class="steps-circle" />
          <h5 class="steps-name">
            Application close
          </h5>
          <p class="steps-description hidden">
            Text
          </p>
        </div>

        <div class="steps-two">
          <p class="steps-date">
            5th June, 2018
          </p>
          <div class="steps-circle" />
          <h5 class="steps-name">
            Top 100 announced
          </h5>
          <p class="steps-description hidden">
            text
          </p>
        </div>

        <div class="steps-three">
          <p class="steps-date">
            12th June, 2018
          </p>
          <div class="steps-circle" />
          <h5 class="steps-name">
            Finalists announced
          </h5>
          <p class="steps-description hidden">
            text
          </p>
        </div>

        <div class="steps-four">
          <p class="steps-date">
            14th June, 2018
          </p>
          <div class="steps-circle" />
          <h5 class="steps-name">
            Winners announced
          </h5>
          <p class="steps-description hidden">
            text
          </p>
        </div>
      </div>
    </div>

    <div class="cee-judges">
      <div class="cee-judges__top">
        <h2>Judges</h2>
        <p>
          Meet CEE Startup Challenge Judges who will be bringing their industry
          knowledge to assess the Winners
        </p>
      </div>
      <div class="cee-judges__items">
        <template v-for="judge in judges">
          <div :key="judge.name" class="cee-judges__item">
            <img :src="judge.imgSrc" />
            <div class="cee-judges__info">
              <p>{{ judge.name }}</p>
              <p class="cee-judges__title">
                {{ judge.title }}
              </p>
              <hr class="divider" />
            </div>
          </div>
        </template>
      </div>
    </div>

    <div class="vestbee-powered marketing-content">
      <div class="row">
        <div>
          <div class="vestbee-powered__top text-center">
            <h2 class="text-center">
              Powered by
            </h2>
            <router-link :to="{ name: 'home' }">
              <img alt="Vestbee" src="/static/img/logo-dark-tagline.png" />
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="partners">
      <div class="partners__top">
        <h2>Partners</h2>
      </div>
      <div class="partners__container">
        <ul class="partners__list">
          <li class="partners__item">
            <a href="http://www.ceeban.org">
              <img src="/static/img-temp/ceeban.png" />
            </a>
          </li>
          <li class="partners__item">
            <a href="http://www.filrougecapital.com/">
              <img src="/static/img-temp/filrougecapital_logo.jpg" />
            </a>
          </li>
          <li class="partners__item">
            <a href="https://keiretsuforum.eu/en/"
              ><img src="/static/img-temp/keiretsu.svg"
            /></a>
          </li>

          <li class="partners__item">
            <a href="http://www.dayonecapital.com/">
              <img src="/static/img-temp/dayonecapital.jpeg" />
            </a>
          </li>
          <li class="partners__item">
            <a href="http://www.bvalue.vc">
              <img src="/static/img-temp/bvalue.png" />
            </a>
          </li>

          <li class="partners__item">
            <a href="http://www.symfoniecapital.com">
              <img src="/static/img-temp/symfonie.png" />
            </a>
          </li>

          <li class="partners__item">
            <a href="http://www.reaktorx.com/"
              ><img src="/static/img-temp/reaktor.png"
            /></a>
          </li>
          <li class="partners__item">
            <a href="http://www.riskybusiness.ro">
              <img src="/static/img-temp/riskybusiness.png" />
            </a>
          </li>
          <li class="partners__item">
            <a href="http://www.capitalventures.pl/en">
              <img src="/static/img-temp/capitalventures.png" />
            </a>
          </li>
          <li class="partners__item">
            <a href="http://www.ad-ventures.pl"
              ><img src="/static/img-temp/adventures.png"
            /></a>
          </li>
          <li class="partners__item">
            <a href="http://www.42angelitos.com"
              ><img src="/static/img-temp/42angelitos.png"
            /></a>
          </li>

          <li class="partners__item">
            <a href="http://startuppoland.org/en/"
              ><img src="/static/img-temp/startuppoland.png"
            /></a>
          </li>
          <li class="partners__item">
            <a href="http://www.startupcampus.hu"
              ><img src="/static/img-temp/startupcampus_logo.png"
            /></a>
          </li>

          <li class="partners__item">
            <a href="http://startupmacedonia.mk/"
              ><img src="/static/img-temp/startupmacedonia.png"
            /></a>
          </li>
          <li class="partners__item">
            <a href="http://www.inkubatorstarter.pl/en"
              ><img src="/static/img-temp/starter.png"
            /></a>
          </li>
          <li class="partners__item">
            <a href="http://www.infoshare.pl"
              ><img src="/static/img-temp/infoshare.png"
            /></a>
          </li>
          <li class="partners__item">
            <a href="http://www.techsylvania.co"
              ><img src="/static/img-temp/techsylvania.svg"
            /></a>
          </li>
        </ul>
      </div>
    </div>
    <div class="marketing-content marketing-ebook">
      <div>
        <h2>Get Free Perfect Pitch Guide Now!</h2>
        <h5>
          Download comprehensive e-book on how to prepare outstanding Investor
          Deck, Elevator and Competition Pitch. Use our practical tips and make
          a big step toward successful fundraising!
        </h5>
        <p>
          <router-link
            class="btn btn-secondary btn-transparent btn-lg"
            :to="{ name: 'perfectPitchEbook' }"
          >
            Get Free E-book Now!
          </router-link>
        </p>
      </div>
      <div class="marketing-ebook__img">
        <img class="img-responsive inline-block" src="/static/img/ebook.png" />
      </div>
    </div>

    <div class="bottom-section">
      <div class="container text-center">
        <div class="row">
          <div class="col-sm-12 col-md-10 col-md-offset-1">
            <h2>Take Your Startup To The Next Level</h2>
            <h3>
              Get wide exposure and valuable contacts for your business to grow
              without leaving your office!
            </h3>
            <router-link
              class="cta btn btn-primary btn-lg"
              :to="{ name: 'organizationPage', params: { orgId: 'vestbee' } }"
            >
              Apply Now!
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <page-footer />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Countdown from 'vuejs-countdown'

export default {
  components: { Countdown },
  computed: mapState({
    fetchingUser: (state) => state.user.fetchInProgress,
    userAuthorized: (state) => state.user.isAuthorized,
    judges: () => [
      {
        name: 'Ewa Chronowska',
        title: 'President, CEE Business Angels Network',
        imgSrc: '/static/img-temp/ewachronowska.jpg',
      },

      {
        name: 'Paweł Maj',
        title: 'Investment Director, bValue',
        imgSrc: '/static/img-temp/PawelMaj.jpg',
      },
      {
        name: 'Jennifer Austin',
        title: 'Partner, Risky Business Ventures',
        imgSrc: '/static/img-temp/JenniferAustin.jpg',
      },
      {
        name: 'Julien Coustaury',
        title: 'Partner, Fil Rouge Capital',
        imgSrc: '/static/img-temp/juliencoustaury.jpg',
      },

      {
        name: 'Janos Toth',
        title: 'Investment Manager, DayOne Capital',
        imgSrc: '/static/img-temp/JanosToth.jpg',
      },

      {
        name: 'Diana Koziarska',
        title: 'CEO, Reaktor',
        imgSrc: '/static/img-temp/dianakoziarska.jpg',
      },
      {
        name: 'Michael Sonenshine',
        title: 'Founding Partner, Symfonie Capital',
        imgSrc: '/static/img-temp/michaelsonenshine.jpg',
      },

      {
        name: 'Magdalena Balcerzak',
        title: 'Manager, CEE Business Angels Network',
        imgSrc: '/static/img-temp/magdalenabalcerzak.jpg',
      },
      {
        name: 'Filip Costal',
        title: 'Director, Keiretsu Forum CEE',
        imgSrc: '/static/img-temp/filipkostal.jpg',
      },

      {
        name: 'Julia Szopa',
        title: 'CEO, Startup Poland',
        imgSrc: '/static/img-temp/juliaszopa.jpg',
      },
      {
        name: 'Ivo Hristov',
        title: 'CEO, Startup Bulgaria',
        imgSrc: '/static/img-temp/Ivo_Hristov.jpg',
      },

      {
        name: 'Natasa Lazaroska',
        title: 'Co-founder, Startup Macedonia',
        imgSrc: '/static/img-temp/Natasa_Lazaroska.jpg',
      },
    ],
  }),
  mounted() {
    this.$store.dispatch('user/fetchNoRedirect')
    // some rare error when getting here from startup list get's user scrolled to the middle or bottom of pitch
    window.scroll(0, 0)
  },
}
</script>

<style scoped lang="scss">
@import '~assets/css/colors.scss';

$blue-light: #2980b9;
$blue-dark: #2c3e50;
$grey-cloud: #ecf0f1;

h2 {
  font-size: 36px;
}

h1,
h2,
h4 {
  font-weight: 400;
  text-align: center;
}

.cta {
  background: $yellow;
  border-color: $yellow;
  margin: 60px auto;
  color: $blue-light;
  text-transform: uppercase;
  font-weight: 600;
  max-width: 268px;

  &:hover {
    color: white;
  }
}

.background-img {
  position: relative;
  width: auto;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.overlay {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

#cee-img {
  background-image: url('/static/images/cee-challenge.jpg');
  height: 600px;
  max-width: 100%;
  max-height: 100%;

  .cee-img__overlay {
    background: $blue-light;
    opacity: 0.7;
  }
}

.img-caption {
  display: flex;
  flex-direction: column;
  color: $white;
  top: 12%;

  h1 {
    margin: 30px auto;
    font-size: 3.2em;
  }

  h3 {
    max-width: 550px;
    margin: 8px auto;
    text-transform: initial;
    font-weight: 300;
    text-align: center;
    line-height: 30px;
  }

  .countdown {
    display: flex;
    margin: 0 auto;
    text-transform: uppercase;

    span {
      margin: 10px;
    }
  }

  @media screen and (max-width: theme('screens.lg')) {
    top: 15%;
    h3 {
      margin: 6px auto;
    }

    .cta {
      margin: 32px auto;
    }
  }
}

.marketing-content {
  h2 {
    color: $blue-light;
    margin-bottom: 11px;
    text-transform: none;
  }

  h3 {
    color: $grey30;
    font-size: 22px;
    font-weight: 300;
    margin-bottom: 11px;
    max-width: 600px;
    text-align: center;
    line-height: 32px;
  }

  h5 {
    margin-bottom: 52px;
    color: $grey30;
    max-width: 580px;
    margin: 0 auto;
  }
}

.startup-investor {
  display: flex;
  justify-content: space-around;
  padding: 22px 0;

  @media screen and (max-width: theme('screens.sm')) {
    flex-direction: column;
  }

  h3 {
    color: $blue-light;
    text-transform: none;
  }

  .cta--secondary {
    color: $grey30;
  }

  .column {
    background-color: initial;
    display: flex;
    justify-content: center;
  }

  .column-content {
    display: flex;
    flex: 0 1 auto;
    flex-direction: column;
    max-width: 400px;

    .column-content__heading {
      display: inline-flex;
      margin: 10px 0 10px -34px;

      .ion {
        margin: 14px;
        fill: $blue-light;
        -webkit-text-fill-color: $blue-light;
      }
    }

    ul {
      list-style: initial;
      margin-top: 20px;
      font-size: 20px;
      font-weight: 300;
    }
  }
}

.cee-sectors {
  h2 {
    color: $white;
    margin: 48px 0 12px;
    z-index: 2;
    text-transform: none;
  }

  h3 {
    color: $white;
    margin: 0 auto;
    z-index: 2;
    font-weight: 200;
    font-size: 22px;
    line-height: 32px;
  }

  .cee-sectors__overlay {
    background: $blue-light;
    opacity: 0.9;
    z-index: 1;
  }

  .cee-sectors__grid {
    background-image: url('/static/img-temp/sectors-bcg.jpg');
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 400px;

    .cee-sectors__items {
      margin: 24px 0;
      display: flex;
      flex-flow: row wrap;
      justify-content: space-around;
    }

    .cee-sector__item {
      z-index: 2;
      width: 300px;
      height: 200px;
      text-align: center;
      display: flex;
      flex: 0 1 25%;
      flex-flow: column;
      justify-content: center;
      color: $grey180;

      i {
        font-size: 50px;
      }

      p {
        margin: 12px auto;
        width: 80%;
        font-size: 1.2em;
        font-weight: 300;
      }
    }

    @media screen and (max-width: theme('screens.md')) {
      .cee-sector__item {
        width: 250px;
        height: 180px;
        flex: 0 0 25%;
      }

      i {
        font-size: 48px;
      }

      p {
        font-size: 16px;
      }
    }

    @media screen and (max-width: theme('screens.sm')) {
      .cee-sector__item {
        flex: 0 0 auto;
      }
    }
  }
}

$outline-width: 0;

.steps-section {
  margin: 60px 0;

  @media screen and (max-width: theme('screens.md')) {
    margin: 60px 0 120px;
  }
}

.section-header {
  color: $blue-dark;
}

.steps-header {
  @extend .section-header;
  margin-bottom: 20px;
  text-align: center;

  @media screen and (max-width: theme('screens.md')) {
    margin-bottom: 30px;
  }
}

.steps-timeline {
  outline: 1px dashed rgba(red, $outline-width);

  @media screen and (max-width: theme('screens.md')) {
    border-left: 2px solid $blue-light;
    margin-left: 25%;
  }

  @media screen and (max-width: theme('screens.sm')) {
    margin-left: 40%;
  }

  @media screen and (min-width: theme('screens.md')) {
    border-top: 2px solid $blue-light;
    margin-top: 86px;
    margin-left: 12.5%;
    margin-right: 12.5%;
  }

  &:after {
    content: '';
    display: table;
    clear: both;
  }
}

.steps-date {
  text-align: center;
  font-size: 16px;
  color: $blue-light;
  padding-bottom: 2px;

  @media screen and (max-width: theme('screens.md')) {
    position: absolute;
    margin-left: -126px;
    margin-top: 2px;
  }
}

.steps-one,
.steps-two,
.steps-three,
.steps-four {
  outline: 1px dashed rgba(green, $outline-width);

  @media screen and (max-width: theme('screens.md')) {
    margin-left: -14px;
  }

  @media screen and (min-width: theme('screens.md')) {
    float: left;
    width: 25%;
    margin-top: -50px;
  }
}
.steps-one,
.steps-two {
  @media screen and (max-width: theme('screens.md')) {
    padding-bottom: 40px;
  }
}
.steps-one {
  @media screen and (min-width: theme('screens.md')) {
    margin-left: -12.5%;
  }
}

.steps-one,
.steps-two,
.steps-three {
  @media screen and (min-width: theme('screens.md')) {
    margin-right: 8%;
  }
}
.steps-three {
  @media screen and (max-width: theme('screens.md')) {
    padding-bottom: 40px;
  }
}
.steps-four {
  @media screen and (max-width: theme('screens.md')) {
    margin-bottom: -100%;
  }
  @media screen and (min-width: theme('screens.md')) {
    // margin-left: 12.5%;
    margin-right: -12.5%;
  }
}

.steps-circle {
  background-color: $blue-light;
  border: 2px solid white;
  display: block;
  margin: auto;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  transition: background-color 0.3s ease-out;

  &:hover {
    background-color: #3498db;
  }

  @media screen and (max-width: theme('screens.md')) {
    float: left;
    margin-right: 20px;
  }
}

.steps-name {
  margin: 10px;
}

.steps-name {
  @extend .section-header;

  @media screen and (min-width: theme('screens.md')) {
    text-align: center;
  }

  @media screen and (max-width: theme('screens.md')) {
    padding-top: 2px;
  }
}
.steps-description {
  overflow: hidden;
  margin: 0;
  text-align: center;

  @media screen and (max-width: theme('screens.md')) {
    margin: 0 44px;
    text-align: left;
  }
}

.cee-judges {
  background-color: $grey180;
  padding: 20px;

  .cee-judges__top {
    margin: 20px auto 36px;
    display: flex;
    flex-flow: column;
    align-items: center;

    h2 {
      color: $blue-light;
      text-transform: none;
    }

    p {
      color: $grey30;
      font-size: 22px;
      font-weight: 300;
      max-width: 600px;
      text-align: center;
    }
  }

  .cee-judges__items {
    display: flex;
    justify-content: space-around;
    flex-flow: row wrap;
    margin-bottom: 24px;

    .cee-judges__item {
      width: 400px;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 24px;

      img {
        width: 150px;
        height: 150px;
        border-radius: 50%;
      }
    }

    @media screen and (min-width: theme('screens.md')) {
      .cee-judges__item {
        flex: 1 0 25%;
      }
    }

    @media screen and (max-width: theme('screens.md')) and (min-width: theme('screens.sm')) {
      .cee-judges__item {
        flex: 1 0 33%;
      }
    }

    @media screen and (max-width: theme('screens.sm')) and (min-width: 550px) {
      .cee-judges__item {
        flex: 1 0 50%;
      }
    }

    .cee-judges__info {
      margin-top: 12px;
      display: flex;
      flex-flow: column;
      align-items: center;

      .cee-judges__title {
        font-size: 16px;
        text-align: center;
      }

      .divider {
        margin-top: 8px;
        margin-bottom: 28px;
        width: 100px;
        border-top: 1px solid $blue-light;
      }
    }
  }
}

.partners {
  padding: 36px 0;
  display: flex;
  flex-direction: column;
  min-height: 320px;

  .partners__top {
    margin: 0 auto;
    color: $blue-dark;
  }

  .partners__list {
    padding: 0;
    list-style: none;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    align-items: center;
  }

  .partners__item {
    padding: 26px 42px;

    img {
      width: 160px;
    }
  }

  @media screen and (min-width: theme('screens.lg')) {
    padding: 26px 30px;

    .partners__item {
      img {
        width: 160px;
      }
    }
  }

  @media screen and (min-width: theme('screens.md')) and (max-width: theme('screens.lg')) {
    .partners__item {
      padding: 30px;
      img {
        width: 180px;
      }
    }
  }

  @media screen and (min-width: theme('screens.sm')) and (max-width: theme('screens.md')) {
    .partners__item {
      padding: 20px;
    }
  }

  @media screen and (max-width: theme('screens.sm')) {
    .partners__item {
      padding: 16px;
      img {
        width: 130px;
      }
    }
  }
}

.vestbee-powered {
  padding-bottom: 20px;

  .vestbee-powered__top {
    h2 {
      margin: 50px 0 50px;
      font-size: 36px;
      color: $blue-dark;
    }

    img {
      width: 200px;
      margin-right: 20px;
    }
  }
}

.marketing-ebook.marketing-content {
  display: flex;
  justify-content: center;
}

.marketing-ebook {
  text-align: right;
  background-color: $grey-cloud;

  h2 {
    text-align: right;
  }

  h5 {
    margin: 30px 0 85px;
  }

  p {
    margin-bottom: 102px;
  }

  .btn-secondary {
    border-color: $blue-light;
    color: $blue-light;

    &:hover {
      background-color: $blue-light;
      color: $white;
    }
  }

  .marketing-ebook__img {
    margin: 70px 0 0 30px;

    img {
      margin: 0;
    }
  }
}

@media screen and (max-width: theme('screens.md')) {
  h2 {
    font-size: 32px;
  }
}

@media screen and (max-width: theme('screens.sm')) {
  .marketing-ebook.marketing-content {
    flex-direction: column;
  }

  .marketing-ebook {
    padding: 0 20px;
    text-align: center;

    h2 {
      text-align: center;
    }

    h5 {
      margin: 30px auto 0 auto;
    }

    p {
      margin: 42px 0 0;
    }

    .marketing-ebook__img {
      img {
        display: none;
      }
    }
  }
}

.bottom-section {
  background-color: $blue-light;
  padding: 48px 0;
  color: $grey180;

  h2 {
    font-size: 36px;
    font-weight: 300;
    margin-bottom: 11px;
    text-align: center;
    line-height: 32px;
    text-transform: none;
  }

  h3 {
    font-size: 22px;
    text-transform: none;
    margin: 36px auto;
    font-weight: 200;
    max-width: 550px;
    line-height: 32px;
  }

  .cta {
    font-size: 16px;
    margin: 36px auto;
    color: $grey30;
  }
}
</style>
